import React, { useRef, useState, useEffect, useCallback } from 'react';

export default function SignatureCanvas({ onSave }) {
  const canvasRef  = useRef(null);
  const drawing    = useRef(false);
  const lastPos    = useRef(null);
  const [isEmpty, setIsEmpty] = useState(true);

  // Sett canvas-størrelse
  useEffect(() => {
    const canvas = canvasRef.current;
    const rect   = canvas.parentElement.getBoundingClientRect();
    canvas.width  = rect.width;
    canvas.height = 180;
    const ctx = canvas.getContext('2d');
    ctx.strokeStyle = '#1a1a2e';
    ctx.lineWidth   = 2.5;
    ctx.lineCap     = 'round';
    ctx.lineJoin    = 'round';
  }, []);

  function getPos(e, canvas) {
    const rect = canvas.getBoundingClientRect();
    if (e.touches) {
      return {
        x: e.touches[0].clientX - rect.left,
        y: e.touches[0].clientY - rect.top,
      };
    }
    return { x: e.clientX - rect.left, y: e.clientY - rect.top };
  }

  const startDraw = useCallback((e) => {
    e.preventDefault();
    drawing.current = true;
    lastPos.current = getPos(e, canvasRef.current);
    setIsEmpty(false);
  }, []);

  const draw = useCallback((e) => {
    e.preventDefault();
    if (!drawing.current) return;
    const canvas = canvasRef.current;
    const ctx    = canvas.getContext('2d');
    const pos    = getPos(e, canvas);
    ctx.beginPath();
    ctx.moveTo(lastPos.current.x, lastPos.current.y);
    ctx.lineTo(pos.x, pos.y);
    ctx.stroke();
    lastPos.current = pos;
  }, []);

  const stopDraw = useCallback(() => {
    drawing.current = false;
  }, []);

  function clear() {
    const canvas = canvasRef.current;
    canvas.getContext('2d').clearRect(0, 0, canvas.width, canvas.height);
    setIsEmpty(true);
    onSave(null);
  }

  function save() {
    if (isEmpty) return;
    const dataUrl = canvasRef.current.toDataURL('image/png');
    onSave(dataUrl);
  }

  return (
    <div>
      <div style={styles.canvasWrapper}>
        <canvas
          ref={canvasRef}
          style={styles.canvas}
          onMouseDown={startDraw}
          onMouseMove={draw}
          onMouseUp={stopDraw}
          onMouseLeave={stopDraw}
          onTouchStart={startDraw}
          onTouchMove={draw}
          onTouchEnd={stopDraw}
        />
        {isEmpty && (
          <div style={styles.placeholder}>Skriv under her</div>
        )}
      </div>
      <div style={styles.actions}>
        <button type="button" style={styles.clearBtn} onClick={clear}>
          Tøm
        </button>
        <button
          type="button"
          style={{ ...styles.saveBtn, opacity: isEmpty ? 0.5 : 1 }}
          onClick={save}
          disabled={isEmpty}
        >
          Bekreft signatur ✓
        </button>
      </div>
    </div>
  );
}

const styles = {
  canvasWrapper: {
    position: 'relative', border: '1px solid #ddd', borderRadius: 8,
    background: '#fafafa', overflow: 'hidden', touchAction: 'none',
  },
  canvas:      { display: 'block', cursor: 'crosshair', width: '100%' },
  placeholder: {
    position: 'absolute', top: '50%', left: '50%',
    transform: 'translate(-50%, -50%)',
    color: '#ccc', fontSize: 14, pointerEvents: 'none', userSelect: 'none',
  },
  actions:  { display: 'flex', gap: 10, marginTop: 8 },
  clearBtn: { flex: 1, padding: '8px', borderRadius: 6, border: '1px solid #ccc', background: '#fff', cursor: 'pointer', fontSize: 13 },
  saveBtn:  { flex: 2, padding: '8px', borderRadius: 6, border: 'none', background: '#27ae60', color: '#fff', cursor: 'pointer', fontWeight: 600, fontSize: 13 },
};
